import { DefaultMessage } from "./user-manager.service";
import { DefaultProductCosts, OemDealerLocation } from "@app-services/oem-dealer.service";
import {
  OemDealerDetails,
  OemDealerForm,
  OemDealerLocationForm,
  EvalUserHelper,
  EvalDealerForm,
  ValueConfig,
  OemDealerBalanceStats,
  RaioXPluginPersonalization,
  TotvsCostCenterConfig
} from "./../model/advertisers";
import { Observable } from "rxjs";
import { environment } from "./../../../../../environments/environment";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { OemDealerFilter, AdvertisersRequestList } from "../model/advertisers";
import { map } from "rxjs/operators";
import { FipePrice } from "../model/admin-models";
import { PageControl } from "@app-model/page-control";

@Injectable({
  providedIn: "root",
})
export class AdminAdvertisersService {
  getDefaultProductCosts() {
    return this.http.get(
      `${environment.api}/admin/defaultProductCosts`,
      {}
    ) as Observable<DefaultProductCosts>;
  }

  getTotvsCostCenterConfig(): Observable<TotvsCostCenterConfig> {
    return this.http.get<TotvsCostCenterConfig>(
      `${environment.api}/oemDealer/totvsCostCenterConfig`
    );
  }

  removeEvalDealer(evalDealerId: string) {
    return this.http.patch(
      `${environment.api}/oemDealer/removeEvalDealer/${evalDealerId}`,
      {}
    ) as Observable<DefaultMessage>;
  }


  updateStatusEvalDealer(evalDealerId: string, inactive: boolean) {
    return this.http.patch(
      `${environment.api}/oemDealer/evalDealerStatus/${evalDealerId}/${inactive}`,
      {}
    ) as Observable<DefaultMessage>;
  }
  constructor(private http: HttpClient) { }

  searchAdvertisers(
    filter: OemDealerFilter
  ): Observable<AdvertisersRequestList> {
    return this.http.post(`${environment.api}/admin/oemDealer/search`, filter);
  }

  getLocationsOemDealers(idOemDealer: string) {
    return this.http.get(
      `${environment.api}/oemDealer/locations/${idOemDealer}`
    ) as Observable<OemDealerLocation[]>;
  }

  saveOemDealer(oemDealer: OemDealerForm): Observable<DefaultMessage> {
    return this.http.post(`${environment.api}/oemDealer/save`, oemDealer);
  }

  saveLocationOemDealers(location: OemDealerLocationForm) {
    return this.http.post(
      `${environment.api}/oemDealer/saveLocation`,
      location
    ) as Observable<OemDealerLocation>;
  }

  updateLocationsOemDealers(locations: string[], oemDealerId: string) {
    return this.http.patch(
      `${environment.api}/oemDealer/updateLocations/${oemDealerId}`,
      locations
    ) as Observable<DefaultMessage>;
  }

  getOemDealer(id: string): Observable<OemDealerDetails> {
    return this.http.get(
      `${environment.api}/oemDealer/details/${id}`
    ).pipe(map((resp: OemDealerDetails) => {
      if (resp.segmentCashbackConfig) {
        const newMap = new Map<string, ValueConfig>();

        for (const key of Object.keys(resp.segmentCashbackConfig)) {
          newMap.set(key, Object.assign(new ValueConfig(), resp.segmentCashbackConfig[key]) as ValueConfig);
        }
        resp.segmentCashbackConfig = newMap;
      }
      const newMap = new Map<string, ValueConfig>();
      if (resp.segmentComissionConfig) {

        for (const key of Object.keys(resp.segmentComissionConfig)) {
          newMap.set(key, Object.assign(new ValueConfig(), resp.segmentComissionConfig[key]) as ValueConfig);
        }
      }
      resp.segmentComissionConfig = newMap;

      resp = Object.assign(new OemDealerDetails(), resp);

      if (resp.balance) {
        resp.balance = Object.assign(new OemDealerBalanceStats(), resp.balance);
      }

      return resp;
    }
    )
    ) as Observable<OemDealerDetails>;
  }

  insertRemoveUserEvalUser(userId: string, evalDealerId: string) {
    return this.http.patch(
      `${environment.api}/oemDealer/addOrRemoveEvalUser/${evalDealerId}/${userId}`,
      {}
    ) as Observable<DefaultMessage>;
  }

  findUsersToAdd(oemDealerId: string) {
    return this.http.get(
      `${environment.api}/oemDealer/findUsersToAdd/${oemDealerId}`
    ) as Observable<EvalUserHelper[]>;
  }

  saveEvalDealer(evalDealer: EvalDealerForm) {
    return this.http.post(
      `${environment.api}/oemDealer/saveEvalDealer`,
      evalDealer
    ) as Observable<DefaultMessage>;
  }

  patchStatusOemDealer(id: string, inactive: boolean) {
    let params = new HttpParams().append("inactive", String(inactive));

    return this.http.patch(
      `${environment.api}/admin/oemDealer/status/${id}`,
      {},
      {
        params: params,
      }
    );
  }

  downloadCSVOfUsers() {
    return this.http.post(
      `${environment.api}/admin/downloadCSVOfUsers`,
      null,
      {
        headers: new HttpHeaders({
          Accept: 'application/csv',
        }),
        responseType: 'blob' as 'json',
      }
    );
  }

  downloadOemDealerReportCSV(filter: Partial<OemDealerFilter> = {}) {
    return this.http.post(
      `${environment.api}/admin/oemDealer/reportCSV`,
      filter,
      {
        headers: new HttpHeaders({
          Accept: 'application/csv',
        }),
        responseType: 'blob' as 'json',
      }
    );
  }

  getFipePriceHistory(pageControl: PageControl): Observable<FipeHistorySearchResult> {
    return this.http.post(`${environment.api}/admin/getFipePriceHistory`, pageControl) as Observable<FipeHistorySearchResult>;
  }

  importFipe(month: number, year: number, car: Blob, motorcycle: Blob, truck: Blob) {
    const formData = new FormData();
    formData.append('car', car);
    formData.append('motorcycle', motorcycle);
    formData.append('truck', truck);
    return this.http.post(`${environment.api}/admin/importFipe/${month}/${year}?importTrims=true`, formData);
  }

  loadPersonalization(personalizationId: string): Observable<RaioXPluginPersonalization> {
    return this.http.get(`${environment.api}/oemDealer/getPersonalizationDetails/${personalizationId}`) as Observable<RaioXPluginPersonalization>;
  }

  createPersonalization(oemDealerId: string, personalization: RaioXPluginPersonalization): Observable<any> {
    return this.http.post(`${environment.api}/oemDealer/temp/updateRaioXPluginPersonalization/${oemDealerId}`, personalization);
  }

  requestWhitelabelPersonalization(oemDealerId: string, request: WhitelabelPersonalizationRequest): Observable<WhitelabelStudioStatusResponse> {
    return this.http.post(`${environment.api}/oemDealer/whitelabel/personalization/${oemDealerId}`, request) as Observable<WhitelabelStudioStatusResponse>;
  }

  requestWhitelabelComponents(personalizationId: string, request: WhitelabelComponentsRequest): Observable<WhitelabelStudioStatusResponse> {
    return this.http.post(`${environment.api}/oemDealer/whitelabel/personalization/${personalizationId}/components`, request) as Observable<WhitelabelStudioStatusResponse>;
  }

  requestWhitelabelAssets(personalizationId: string, request: WhitelabelAssetsRequest): Observable<WhitelabelStudioStatusResponse> {
    return this.http.post(`${environment.api}/oemDealer/whitelabel/personalization/${personalizationId}/assets`, request) as Observable<WhitelabelStudioStatusResponse>;
  }

  getWhitelabelPersonalizationStatus(personalizationId: string): Observable<WhitelabelPersonalizationStatusResponse> {
    return this.http.get(`${environment.api}/oemDealer/whitelabel/personalization/status/${personalizationId}`) as Observable<WhitelabelPersonalizationStatusResponse>;
  }

  deleteModel(personalizationId: string) {
    return this.http.post(`${environment.api}/oemDealer/disablePersonalization/${personalizationId}`, null);
  }
}

export class FipeHistorySearchResult {
  actualPage: number;
  data: FipePrice[];
  numberOfPages: number;
  totalElements: number;
}

export class ScrapingHistorySearchResult {
  actualPage: number;
  data: ScrapingHistory[];
  numberOfPages: number;
  totalElements: number;
}

export class ScrapingHistory{
  id: string;
  createdAt: Date;
  finishedAt: Date;
  syncs: number;
  planApiCredits: number;
  usedApiCredits: number;
  status: string;
}

export type WhitelabelComponentTemplateId =
  'CATEGORY_GRID'
  | 'BRANDS_FEATURE_SHOWCASE'
  | 'CATEGORY_BENTO_GRID'
  | 'PRODUCT_VITRINE_WITH_BANNER'
  | 'PREMIUM_CATEGORY_CARDS'
  | 'HERO_BENEFITS_WITH_IMAGE'
  | 'BRAND_LOGO_CAROUSEL'
  | 'IMAGE_GRID'
  | 'TRUST_BENEFITS_CARDS'
  | 'HORIZONTAL_CATEGORY_CARDS'
  | 'TESTIMONIAL_CARDS'
  | 'FEATURED_VEHICLE_CARD';

export type WhitelabelTarget = 'MOBILE' | 'DESKTOP';

export interface WhitelabelGridConfig {
  itemsPerRow?: number;
  shape?: 'SQUARE' | 'RECTANGLE' | 'ROUND';
  format?: 'INLINE' | 'BLOCK';
  lineHeight?: number;
}

export interface WhitelabelComponentConfig {
  templateId: WhitelabelComponentTemplateId;
  brief: string;
  expectedItems: number;
  tone?: string;
  order: number;
  targets: WhitelabelTarget[];
  gridConfig?: WhitelabelGridConfig;
}

export interface WhitelabelPersonalizationRequest {
  name: string;
  alternativeDomain: string;
  primaryColor: string;
  offerColor: string;
  buttonColor: string;
  logoUrl: string;
  visualBriefing?: string;
  components: WhitelabelComponentConfig[];
}

export interface WhitelabelComponentsRequest {
  components: WhitelabelComponentConfig[];
}

export type WhitelabelAssetType = 'BANNER';

export interface WhitelabelAssetConfig {
  assetType: WhitelabelAssetType;
  brief: string;
  expectedItems: number;
  tone?: string;
  order: number;
}

export interface WhitelabelAssetsRequest {
  assets: WhitelabelAssetConfig[];
}

export interface WhitelabelStudioStatusResponse {
  success: boolean;
  status: number;
  message: string;
  personalizationId: string;
}

export type WhitelabelCreationStatus = 'PROCESSING' | 'DONE' | 'FAILED';
export type WhitelabelSagaStep = 'PERSONALIZATION' | 'ASSETS' | 'COMPONENTS';

export interface WhitelabelPersonalizationStatusResponse {
  personalizationId: string;
  oemDealerId: string;
  currentStep: WhitelabelSagaStep;
  status: WhitelabelCreationStatus;
  errorMessage?: string;
}
